<div *ngIf="settings"
     style="position: relative;"
     class="container" 
     [ngStyle]="{'justify-content': settings.alignment=='start'?'flex-start'
                                     :settings.alignment=='end'?'flex-end'
                                     :'center',
                  'max-width': settings.width}">
    <div id="wrapper" style="position: relative;" [ngStyle]="{'padding': '0 '+settings.spacing}" *ngFor="let tile of tiles; let i = index">
        <div class="tile" 
            [style.--line-width]="lineWidth"
            [style.--line-color]="settings.completedColor"
            [style.--line-inactive-color]="settings.uncompletedColor"
            [ngStyle]="{
                'width': settings.tileSettings.icon.width
            }"
            [class.selected]="selectedId==tile.id"
            [class.last]="i==tiles.length-1"
            [class.inactive]="inactiveTilesIds.includes(tile.id)"
            (click)="settings.linear==false ? select(tile.id) : null"
            (mouseover)="hover(tile.id)"
            (mouseleave)="unhover()">

            <div class="layout vertical center top">
                <app-icon *ngIf="tile.icon" 
                          [id]="tile.icon" 
                          [settings]="!inactiveTilesIds.includes(tile.id) ? settings.completedTileSettings.icon
                                      : selectedId==tile.id ? settings.selectedTileSettings.icon
                                      : (hoverId==tile.id && settings.linear==false) ? settings.hoverTileSettings.icon 
                                      : settings.tileSettings.icon"></app-icon>
                <div *ngIf="!isXxxs" style="text-align: center; margin-top: 4px; white-space: no-wrap;">{{tile.label | translate}}</div>
            </div>
        </div>
    </div>
</div>
